import * as viewApi from '@/api/viewer'

const viewer = {
  state: {
    defaultViewPoint: {},
    frequentViewPoint: []
  },
  // mutations: {
  //   SET_DEFAULT_VIEW: (state, data) => {
  //     state.defaultViewPoint = data
  //   },
  //   SET_FREQUENT_VIEW: (state, data) => {
  //     state.frequentViewPoint = data
  //   }
  // },
  actions: {
    // 获取默认视点
    getDefaultViewPoint ({ commit, dispatch, state, getters }, data) {
      return new Promise((resolve, reject) => {
        viewApi.getDefaultViewPoint({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            state.defaultViewPoint = response.data
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取常用视点
    getFrequentlyViewPoint ({ commit, dispatch, state, getters }, data) {
      return new Promise((resolve, reject) => {
        viewApi.getFrequentlyViewPoint({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            state.frequentViewPoint = response.data
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default viewer
